import { createAction, props } from '@ngrx/store';

export const changeCategoryCode = createAction(
  '[Util Data] change Option',
  props<{ categoryCode: number }>()
);

export const saveCanalOrigin = createAction(
  '[Util Data] save trace origin',
  props<{ canal: string }>()
);
